(function () {
  'use strict';

  var R = window.Rook || {};

  function formatMoney(cents) {
    var fmt = R.moneyFormat || '${{amount}}';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        default: return delim(cents, 2, ',', '.');
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Header: solid on scroll, mobile menu */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40 || !header.classList.contains('site-header--overlay')); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var toggle = header.querySelector('.menu-toggle');
    var mobile = document.querySelector('.mobile-nav');
    if (toggle && mobile) {
      toggle.addEventListener('click', function () {
        var open = mobile.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
        header.classList.add('is-solid');
        if (!open) onScroll();
      });
      mobile.addEventListener('click', function (e) { if (e.target.tagName === 'A') { mobile.classList.remove('is-open'); onScroll(); } });
    }
  }

  /* Reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(root) {
    root.querySelectorAll('.reveal').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  }
  initReveal(document);

  /* Home grid: topic chips + color filter + sort (featured collection) */
  document.querySelectorAll('[data-shop-bar]').forEach(function (bar) {
    var grid = document.getElementById(bar.getAttribute('data-shop-bar'));
    if (!grid) return;
    var chipsWrap = bar.querySelector('[data-chips]');
    var colorSel = bar.querySelector('[data-color-filter]');
    var sortSel = bar.querySelector('[data-grid-sort]');
    var countEl = bar.querySelector('[data-grid-count]');
    var emptyEl = bar.parentNode.querySelector('[data-grid-empty]');
    var cards = [].slice.call(grid.querySelectorAll('.card'));
    cards.forEach(function (c, i) { c.setAttribute('data-pos', i); });
    var tagsWanted = [];
    function apply() {
      var color = colorSel ? colorSel.value : '';
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').toLowerCase().split('|');
        var okTag = !tagsWanted.length || tagsWanted.some(function (t) { return tags.indexOf(t) > -1; });
        var okColor = !color || card.getAttribute('data-color') === color;
        var show = okTag && okColor;
        card.classList.toggle('is-hidden', !show);
        if (show) { shown++; card.classList.add('is-in'); }
      });
      var mode = sortSel ? sortSel.value : '';
      cards.slice().sort(function (a, b) {
        if (mode === 'az' || mode === 'za') {
          var r = a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
          return mode === 'az' ? r : -r;
        }
        if (mode === 'newest') return (+b.getAttribute('data-created')) - (+a.getAttribute('data-created')) || (+a.getAttribute('data-pos')) - (+b.getAttribute('data-pos'));
        return (+a.getAttribute('data-pos')) - (+b.getAttribute('data-pos'));
      }).forEach(function (c) { grid.appendChild(c); });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' design' : ' designs');
      if (emptyEl) emptyEl.hidden = shown > 0;
    }
    if (chipsWrap) chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('.chip');
      if (!chip) return;
      chipsWrap.querySelectorAll('.chip').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      tagsWanted = (chip.getAttribute('data-tag') || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      apply();
    });
    if (colorSel) colorSel.addEventListener('change', apply);
    if (sortSel) sortSel.addEventListener('change', apply);
    if (countEl) countEl.textContent = cards.length + ' designs';
  });

  /* 3D tilt on product photos (pointer devices only, respects reduced motion) */
  var canTilt = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var tiltAmp = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 6 : 14;
  function initTilt(root) {
    if (!canTilt) return;
    root.querySelectorAll('[data-tilt]').forEach(function (el) {
      var frame = null;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          el.style.setProperty('--ry', ((x - 0.5) * tiltAmp).toFixed(2) + 'deg');
          el.style.setProperty('--rx', ((0.5 - y) * tiltAmp).toFixed(2) + 'deg');
          el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
          el.classList.add('is-tilting');
        });
      });
      el.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        el.classList.remove('is-tilting');
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }
  initTilt(document);

  /* Collection sort */
  var sortSel = document.querySelector('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Variant pickers (cards + product page) */
  function initPicker(root) {
    var json = root.querySelector('.js-variants');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    var selected = current.options.slice();
    // Product page: make the shopper pick a size (no size preselected unless ?variant= is in the URL)
    var sizeIndex = -1;
    if (root.hasAttribute('data-product-page') && !/[?&]variant=/.test(location.search)) {
      sizeIndex = +root.getAttribute('data-size-index');
      if (sizeIndex >= 0) selected[sizeIndex] = null;
    }

    function sync() {
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      root.querySelectorAll('.opt').forEach(function (b) {
        var i = +b.getAttribute('data-index');
        b.classList.toggle('is-active', selected[i] === b.value);
        var test = selected.slice(); test[i] = b.value;
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
        b.disabled = !v || !v.available;
      });
      if (match) idInput.value = match.id;
      if (btn) {
        var ok = match && match.available;
        var needSize = sizeIndex >= 0 && selected[sizeIndex] == null;
        btn.disabled = !ok;
        var label = btn.querySelector('[data-label]');
        if (label) label.textContent = needSize ? (btn.getAttribute('data-text-select') || 'Select a size') : (ok ? btn.getAttribute('data-text-add') : btn.getAttribute('data-text-soldout'));
        root.classList.toggle('needs-size', needSize);
      }
      if (priceEl && match) {
        priceEl.innerHTML = (match.compare_at_price > match.price ? '<s>' + formatMoney(match.compare_at_price) + '</s>' : '') + formatMoney(match.price);
      }
      if (match && match.featured_media && root.hasAttribute('data-product-page')) {
        document.dispatchEvent(new CustomEvent('rook:variant-media', { detail: match.featured_media.id }));
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('.opt');
      if (!b || b.disabled) return;
      e.preventDefault();
      selected[+b.getAttribute('data-index')] = b.value;
      sync();
      // Card quick add: tapping a size adds it straight to the bag
      if (b.closest('[data-quick-size]')) {
        var qf = root.querySelector('form[data-ajax-add]');
        var qb = qf && qf.querySelector('[data-add-button]');
        if (qf && qb && !qb.disabled) {
          b.classList.add('is-adding');
          setTimeout(function () { b.classList.remove('is-adding'); }, 1200);
          if (qf.requestSubmit) qf.requestSubmit(); else qb.click();
        }
      }
    });
    sync();
  }
  document.querySelectorAll('[data-picker]').forEach(initPicker);

  /* Product gallery: arrows, thumbnails, swipe, keyboard, variant image */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    var counter = g.querySelector('[data-gallery-current]');
    if (slides.length < 2) return;
    var index = 0;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === index); });
      var active = thumbs[index];
      if (active && active.parentNode) active.parentNode.scrollLeft = active.offsetLeft - 40;
      if (counter) counter.textContent = index + 1;
    }
    g.querySelector('[data-gallery-prev]').addEventListener('click', function () { go(index - 1); });
    g.querySelector('[data-gallery-next]').addEventListener('click', function () { go(index + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-gallery-thumb')); }); });
    var main = g.querySelector('.gallery__main');
    main.setAttribute('tabindex', '0');
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(index - 1);
      if (e.key === 'ArrowRight') go(index + 1);
    });
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
      startX = null;
    });
    document.addEventListener('rook:variant-media', function (e) {
      slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(e.detail)) go(k); });
    });
  });

  /* Product recommendations (Shopify engine, loaded after page) */
  document.querySelectorAll('[data-recs]').forEach(function (box) {
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (!fresh || !fresh.innerHTML.trim()) return;
      box.innerHTML = fresh.innerHTML;
      box.querySelectorAll('[data-picker]').forEach(initPicker);
      initTilt(box);
      initReveal(box);
    }).catch(function () {});
  });

  /* Scroll effects: progress bar, hero parallax, header state */
  var progress = document.querySelector('.scroll-progress');
  var heroMedia = document.querySelector('.hero__media');
  var heroContent = document.querySelector('.hero__content');
  var gentle = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;
  function onScrollFx() {
    var y = window.scrollY;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
    if (heroMedia && y < window.innerHeight * 1.2) {
      heroMedia.style.transform = 'translate3d(0,' + (y * (gentle ? 0.15 : 0.35)).toFixed(1) + 'px,0) scale(1.08)';
      if (heroContent) heroContent.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.8)).toFixed(3);
    }
    if (header) header.classList.toggle('is-scrolled', y > 10);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScrollFx); }
  }, { passive: true });
  onScrollFx();

  /* Cart drawer */
  var drawer = document.querySelector('.drawer');
  var body = document.body;

  function openDrawer() { body.classList.add('drawer-open'); }
  function closeDrawer() { body.classList.remove('drawer-open'); }

  function updateCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }

  var STR = R.strings || {};
  function tpl(str, vars) { return String(str || '').replace(/__(\w+)__/g, function (_, k) { k = k.toLowerCase(); return vars[k] != null ? vars[k] : ''; }); }
  function etaRange(min, max) {
    function add(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    return add(min) + ' – ' + add(max);
  }
  document.querySelectorAll('[data-cart-eta]').forEach(function (el) { el.textContent = etaRange(5, 13); });

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    var bodyEl = drawer.querySelector('.drawer__body');
    var foot = drawer.querySelector('.drawer__foot');
    var perks = drawer.querySelector('[data-cart-perks]');
    drawer.querySelector('[data-drawer-count]').textContent = cart.item_count;
    if (!cart.items.length) {
      bodyEl.innerHTML = drawer.querySelector('template[data-empty]').innerHTML;
      foot.hidden = true;
      if (perks) perks.hidden = true;
      return;
    }
    foot.hidden = false;

    /* free shipping progress + multi-buy hint */
    if (perks) {
      perks.hidden = false;
      var goal = +drawer.getAttribute('data-free-ship') || 0;
      var left = Math.max(0, goal - cart.total_price);
      var shipText = perks.querySelector('[data-ship-text]');
      var shipFill = perks.querySelector('[data-ship-fill]');
      if (goal) {
        shipText.innerHTML = left > 0 ? tpl(STR.shipAway, { amount: '<strong>' + formatMoney(left) + '</strong>' }) : STR.shipDone;
        shipFill.style.width = Math.min(100, cart.total_price / goal * 100) + '%';
        perks.querySelector('.ship-bar').classList.toggle('is-done', left === 0);
      }
      var need = +drawer.getAttribute('data-bundle-qty') || 0;
      var hint = perks.querySelector('[data-bundle-hint]');
      if (need && hint) {
        var missing = need - cart.item_count;
        hint.hidden = false;
        hint.classList.toggle('is-done', missing <= 0);
        hint.textContent = missing > 0 ? tpl(STR.bundleMore, { n: missing }) : STR.bundleDone;
      }
    }

    bodyEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '';
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) {
        return '<span>' + escapeHtml(o.name) + ': <strong>' + escapeHtml(o.value) + '</strong></span>';
      }).join('');
      var price = it.original_line_price > it.final_line_price
        ? '<s>' + formatMoney(it.original_line_price) + '</s> ' + formatMoney(it.final_line_price)
        : formatMoney(it.final_line_price);
      return '<div class="line" data-key="' + it.key + '">' +
        '<a class="line__img" href="' + it.url + '">' + img + '</a>' +
        '<div><div class="line__top"><div><a class="line__title" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' +
        (opts ? '<div class="line__opts">' + opts + '</div>' : '') +
        '<div class="line__made">' + escapeHtml(STR.lineMade || '') + '</div></div>' +
        '<div class="card__price line__price">' + price + '</div></div>' +
        '<div class="line__bottom"><div class="qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<button type="button" class="line__remove" data-qty="0">' + escapeHtml(STR.remove || 'Remove') + '</button></div></div></div>';
    }).join('');

    /* savings from automatic discounts / codes */
    var disc = drawer.querySelector('[data-cart-discounts]');
    if (disc) {
      var saved = cart.original_total_price - cart.total_price;
      var titles = [];
      cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && titles.indexOf(t) === -1) titles.push(t); }); });
      (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) === -1) titles.push(a.title); });
      disc.innerHTML = saved > 0 ? '<div class="drawer__saving"><span>' + escapeHtml(titles.join(' · ') || STR.savings || 'Savings') + '</span><span>−' + formatMoney(saved) + '</span></div>' : '';
    }
    drawer.querySelector('[data-subtotal]').textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(R.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    drawer.classList.add('is-loading');
    return fetch(R.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      drawer.classList.remove('is-loading');
    });
  }

  if (drawer) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-cart]')) { e.preventDefault(); fetchCart().then(renderCart); openDrawer(); }
      if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); }
      var q = e.target.closest('.drawer [data-qty]');
      if (q) { changeLine(q.closest('.line').getAttribute('data-key'), +q.getAttribute('data-qty')); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]') || form.querySelector('button[type="submit"]');
      var label = btn && btn.querySelector('[data-label]');
      if (btn) btn.disabled = true;
      fetch(R.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw data; return data; });
      }).then(function () {
        if (btn) {
          btn.classList.add('is-added');
          if (label) label.textContent = btn.getAttribute('data-text-added') || 'Added';
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (label) label.textContent = btn.getAttribute('data-text-add') || 'Add';
          }, 1600);
        }
        return fetchCart();
      }).then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* Favorites (wishlist) — stored in this browser */
  var FAV_KEY = 'ih_favorites';
  function readFavs() {
    try { var v = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function writeFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintFavs(root) {
    var list = readFavs();
    (root || document).querySelectorAll('[data-fav]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-fav')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', b.getAttribute(on ? 'data-label-remove' : 'data-label-add'));
      var t = b.querySelector('[data-fav-text]');
      if (t) t.textContent = t.getAttribute(on ? 'data-text-remove' : 'data-text-add');
    });
    document.querySelectorAll('[data-fav-count]').forEach(function (c) {
      c.textContent = list.length;
      c.setAttribute('data-count', list.length);
      c.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-fav');
    var list = readFavs();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    writeFavs(list);
    b.classList.remove('is-pop'); void b.offsetWidth; if (i === -1) b.classList.add('is-pop');
    paintFavs();
    document.dispatchEvent(new CustomEvent('ih:favorites-changed'));
  });
  window.addEventListener('storage', function (e) { if (e.key === FAV_KEY) paintFavs(); });
  paintFavs();

  var favPage = document.querySelector('[data-favorites-page]');
  if (favPage) {
    var favGrid = favPage.querySelector('[data-favorites-grid]');
    var favEmpty = favPage.querySelector('[data-favorites-empty]');
    var favSignup = favPage.querySelector('[data-favorites-signup]');
    var favNote = favPage.querySelector('[data-favorites-note]');
    var renderFavPage = function () {
      var list = readFavs();
      favEmpty.hidden = list.length > 0;
      if (favSignup) favSignup.hidden = list.length === 0;
      if (favNote) favNote.value = list.length ? 'Favorites: ' + list.join(', ') : '';
      favGrid.querySelectorAll('.card').forEach(function (c) {
        if (list.indexOf(c.getAttribute('data-handle')) === -1) c.remove();
      });
      var have = [].map.call(favGrid.querySelectorAll('.card'), function (c) { return c.getAttribute('data-handle'); });
      list.forEach(function (handle, pos) {
        if (have.indexOf(handle) > -1) return;
        fetch('/products/' + encodeURIComponent(handle) + '?view=card').then(function (r) {
          if (r.status === 404) throw new Error('gone');
          if (!r.ok) throw new Error('network');
          return r.text();
        }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.card');
          if (!card || readFavs().indexOf(handle) === -1 || favGrid.querySelector('.card[data-handle="' + handle + '"]')) return;
          card.setAttribute('data-handle', handle);
          card.style.order = pos;
          favGrid.appendChild(card);
          initPicker(card);
          initTilt(card);
          initReveal(card);
          paintFavs(card);
        }).catch(function (err) {
          if (err && err.message === 'gone') {
            // product no longer exists: drop it from the list
            writeFavs(readFavs().filter(function (x) { return x !== handle; }));
            paintFavs();
          }
        });
      });
    };
    renderFavPage();
    document.addEventListener('ih:favorites-changed', renderFavPage);
  }

  /* Delivery estimate (business days) */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (!(min > 0) || !(max >= min)) return;
    function addBusinessDays(date, n) {
      var d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var out = el.querySelector('[data-delivery-range]');
    if (out) out.textContent = fmt(addBusinessDays(new Date(), min)) + ' – ' + fmt(addBusinessDays(new Date(), max));
  });

  /* Sticky add-to-cart bar (phones) */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('.product__form');
  if (stickyBar && mainForm) {
    var mainBtn = mainForm.querySelector('[data-add-button]');
    var stickyBtn = stickyBar.querySelector('[data-sticky-go]');
    var stickyPrice = stickyBar.querySelector('[data-sticky-price]');
    var pagePrice = document.querySelector('.product__info [data-price]');
    var stickyTick = false;
    var updateSticky = function () {
      stickyTick = false;
      // show only once the buy button has scrolled up out of view
      var show = mainForm.getBoundingClientRect().bottom < 0;
      if (show === stickyBar.classList.contains('is-visible')) return;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
      if (stickyPrice && pagePrice) stickyPrice.innerHTML = pagePrice.innerHTML;
    };
    window.addEventListener('scroll', function () {
      if (!stickyTick) { stickyTick = true; requestAnimationFrame(updateSticky); }
    }, { passive: true });
    updateSticky();
    stickyBtn.addEventListener('click', function () {
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      } else if (document.querySelector('.product__info.needs-size')) {
        var sz = document.querySelector('.product__option:not(.is-single)');
        (sz || document.querySelector('.product__info')).scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        document.querySelector('.product__info').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* Full-screen photo viewer (product page) */
  var lb = document.querySelector('[data-lightbox]');
  var gal = document.querySelector('[data-gallery]');
  if (lb && gal) {
    var lbImg = lb.querySelector('[data-lightbox-img]');
    var lbCount = lb.querySelector('[data-lightbox-count]');
    var lbStage = lb.querySelector('[data-lightbox-stage]');
    var lbSlides = gal.querySelectorAll('.gallery__slide img');
    var lbIndex = 0;
    var bigSrc = function (img) {
      var src = img.currentSrc || img.src;
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=2400') : src;
    };
    var lbShow = function (i) {
      if (!lbSlides.length) return;
      lbIndex = (i + lbSlides.length) % lbSlides.length;
      lbImg.src = bigSrc(lbSlides[lbIndex]);
      lbImg.alt = lbSlides[lbIndex].alt || '';
      lbStage.classList.remove('is-zoomed');
      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + lbSlides.length;
    };
    var lbOpen = function (at) {
      var active = gal.querySelector('.gallery__slide.is-active');
      lbShow(typeof at === 'number' ? at : (active ? +active.getAttribute('data-index') : 0));
      lb.hidden = false;
      document.body.classList.add('lightbox-open');
      lb.querySelector('[data-lightbox-close]').focus();
    };
    var lbClose = function () { lb.hidden = true; document.body.classList.remove('lightbox-open'); };
    gal.querySelector('.gallery__main').addEventListener('click', function (e) {
      if (e.target.closest('.gallery__nav')) return;
      lbOpen();
    });
    gal.querySelectorAll('[data-lightbox-index]').forEach(function (cell) {
      cell.addEventListener('click', function () { lbOpen(+cell.getAttribute('data-lightbox-index')); });
    });
    lb.querySelector('[data-lightbox-close]').addEventListener('click', lbClose);
    lb.querySelector('[data-lightbox-prev]').addEventListener('click', function () { lbShow(lbIndex - 1); });
    lb.querySelector('[data-lightbox-next]').addEventListener('click', function () { lbShow(lbIndex + 1); });
    var setOrigin = function (e) {
      var r = lbImg.getBoundingClientRect();
      lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    };
    lbStage.addEventListener('click', function (e) {
      if (e.target !== lbImg) { lbClose(); return; }
      setOrigin(e);
      lbStage.classList.toggle('is-zoomed');
    });
    lbStage.addEventListener('mousemove', function (e) {
      if (lbStage.classList.contains('is-zoomed')) setOrigin(e);
    });
    var lbX = null;
    lbStage.addEventListener('touchstart', function (e) { lbX = e.touches[0].clientX; }, { passive: true });
    lbStage.addEventListener('touchend', function (e) {
      if (lbX === null || lbStage.classList.contains('is-zoomed')) return;
      var dx = e.changedTouches[0].clientX - lbX;
      if (Math.abs(dx) > 40) lbShow(dx < 0 ? lbIndex + 1 : lbIndex - 1);
      lbX = null;
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });
  }

  /* Email pop-up */
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var POP_KEY = 'ih_popup_until';
    var popStore = {
      get: function () { try { return +localStorage.getItem(POP_KEY) || 0; } catch (e) { return 0; } },
      snooze: function (days) { try { localStorage.setItem(POP_KEY, String(Date.now() + days * 864e5)); } catch (e) {} }
    };
    var opened = false;
    var openPopup = function (force) {
      if (opened) return;
      if (!force && (body.classList.contains('drawer-open') || body.classList.contains('lightbox-open'))) return;
      opened = true;
      popup.hidden = false;
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
      var field = popup.querySelector('input[type="email"]');
      if (field && window.matchMedia('(hover: hover)').matches) field.focus();
    };
    var closePopup = function () {
      popup.classList.remove('is-open');
      setTimeout(function () { popup.hidden = true; }, 250);
      popStore.snooze(14);
    };
    popup.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) closePopup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) closePopup(); });
    var popForm = popup.querySelector('form');
    if (popForm) popForm.addEventListener('submit', function () { popStore.snooze(365); });

    var posted = /customer_posted=true/.test(location.search);
    if (posted && /signup-popup/.test(location.hash)) {
      popStore.snooze(365);
      openPopup(true);
    } else if (!posted && popStore.get() < Date.now()) {
      var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 12) * 1000;
      var depth = (parseInt(popup.getAttribute('data-scroll'), 10) || 45) / 100;
      setTimeout(openPopup, delay);
      var onDepth = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= depth) { window.removeEventListener('scroll', onDepth); openPopup(); }
      };
      window.addEventListener('scroll', onDepth, { passive: true });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) openPopup(); });
      }
    } else if (posted) {
      popStore.snooze(365);
    }
  }

  /* Reviews: show/hide the form, reopen it after sending */
  var reviewToggle = document.querySelector('[data-review-toggle]');
  var reviewWrap = document.querySelector('[data-review-form]');
  if (reviewToggle && reviewWrap) {
    var openReview = function (scroll) {
      reviewWrap.hidden = false;
      reviewToggle.setAttribute('aria-expanded', 'true');
      if (scroll) reviewWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    reviewToggle.addEventListener('click', function () {
      if (reviewWrap.hidden) { openReview(true); } else { reviewWrap.hidden = true; reviewToggle.setAttribute('aria-expanded', 'false'); }
    });
    if (reviewWrap.querySelector('[data-review-sent], .form-error') || /review-form/.test(location.hash)) openReview(true);
  }

  /* Track order: tracking number lookup (opens the multi-carrier tracker) */
  document.querySelectorAll('[data-track-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = (f.querySelector('input[name="number"]').value || '').replace(/\s+/g, '');
      if (!n) return;
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(n), '_blank', 'noopener');
    });
  });

  /* Refer a friend: copy link + native share */
  var referCopy = document.querySelector('[data-refer-copy]');
  var referUrl = document.querySelector('[data-refer-url]');
  if (referCopy && referUrl) {
    referCopy.addEventListener('click', function () {
      var done = function () {
        var old = referCopy.textContent;
        referCopy.textContent = referCopy.getAttribute('data-text-copied');
        setTimeout(function () { referCopy.textContent = old; }, 1800);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(referUrl.value).then(done, function () { referUrl.select(); document.execCommand('copy'); done(); });
      else { referUrl.select(); document.execCommand('copy'); done(); }
    });
    referUrl.addEventListener('focus', function () { referUrl.select(); });
  }
  var referShare = document.querySelector('[data-refer-share]');
  if (referShare && navigator.share) {
    referShare.hidden = false;
    referShare.addEventListener('click', function () {
      navigator.share({ title: referShare.getAttribute('data-title'), text: referShare.getAttribute('data-text'), url: referShare.getAttribute('data-url') }).catch(function () {});
    });
  }

  /* Announcement bar: rotate messages */
  document.querySelectorAll('[data-rotate]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    var paused = false;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });
})();

/* Size guide opens in a pop-up on product pages (falls back to the page link) */
(function () {
  var link = document.querySelector('.product__info .size-link');
  if (!link || typeof HTMLDialogElement === 'undefined') return;
  var dlg, loaded = false;
  link.addEventListener('click', function (e) {
    e.preventDefault();
    var url = link.getAttribute('href'), anchor = (url.split('#')[1] || '');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'sg-modal';
      dlg.innerHTML = '<div class="sg-modal__head"><span>' + link.textContent + '</span><button type="button" class="sg-modal__close" aria-label="Close">&times;</button></div><div class="sg-modal__body">Loading…</div><div class="sg-modal__foot"><a href="' + url + '">Open the full size guide</a></div>';
      document.body.appendChild(dlg);
      dlg.querySelector('.sg-modal__close').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
    }
    dlg.showModal();
    if (loaded) return;
    fetch(url.split('#')[0]).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = (anchor && doc.getElementById(anchor)) || doc.querySelector('.size-table-wrap') && doc.querySelector('.size-table-wrap').closest('section');
      if (!sec) { location.href = url; return; }
      var head = sec.querySelector('.section-head'); if (head) head.remove();
      sec.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      dlg.querySelector('.sg-modal__body').innerHTML = '';
      dlg.querySelector('.sg-modal__body').appendChild(sec);
      loaded = true;
    }).catch(function () { location.href = url; });
  });
})();
